export const isCourseDetailLoadedGetter = "is Course Detail Loaded getter";

export const courseDetailGetter = "course detail getter";
